module.exports = __webpack_public_path__ + "static/media/Im_progress_gacha4d8e188ce42efaeeaa482c7e421c2135.webp";